import React from 'react';
import { AdminDashboard } from './AdminDashboard';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Briefcase, FileText, Building2, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

export const AdminHome = () => {
  const quickLinks = [
    {
      title: 'Services',
      description: 'Manage your service offerings',
      icon: Briefcase,
      path: '/admin/services',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      title: 'Projects',
      description: 'Manage your project portfolio',
      icon: FileText,
      path: '/admin/projects',
      color: 'from-green-500 to-emerald-500'
    },
    {
      title: 'Company Info',
      description: 'Update company details',
      icon: Building2,
      path: '/admin/company',
      color: 'from-purple-500 to-pink-500'
    }
  ];

  return (
    <AdminDashboard>
      <div className="space-y-6">
        {/* Welcome Section */}
        <div>
          <h1 className="text-3xl font-bold text-slate-900">Welcome to Admin Dashboard</h1>
          <p className="text-slate-600 mt-1">Manage your Elzalira website content</p>
        </div>

        {/* Quick Links */}
        <div className="grid md:grid-cols-3 gap-6">
          {quickLinks.map((link) => {
            const Icon = link.icon;
            return (
              <Link key={link.path} to={link.path}>
                <Card className="hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer border-0 shadow-lg">
                  <CardHeader>
                    <div className={`w-16 h-16 bg-gradient-to-br ${link.color} rounded-2xl flex items-center justify-center mb-4 shadow-lg`}>
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                    <CardTitle className="text-xl">{link.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-slate-600">{link.description}</p>
                  </CardContent>
                </Card>
              </Link>
            );
          })}
        </div>

        {/* Info Cards */}
        <div className="grid md:grid-cols-2 gap-6 mt-8">
          <Card className="bg-gradient-to-br from-[#1E4E9E]/5 to-[#00B050]/5">
            <CardHeader>
              <CardTitle className="flex items-center space-x-2">
                <Mail className="w-5 h-5 text-[#1E4E9E]" />
                <span>Quick Tips</span>
              </CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="space-y-2 text-sm text-slate-600">
                <li>• Use clear, descriptive titles for services and projects</li>
                <li>• Upload high-quality images for better visual impact</li>
                <li>• Keep descriptions concise and informative</li>
                <li>• Regular updates keep your website fresh and engaging</li>
              </ul>
            </CardContent>
          </Card>

          <Card className="bg-gradient-to-br from-[#00B050]/5 to-[#1E4E9E]/5">
            <CardHeader>
              <CardTitle>Website Status</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-slate-600">Website</span>
                  <span className="text-sm font-semibold text-green-600">Live</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-slate-600">Domain</span>
                  <span className="text-sm font-semibold text-slate-900">www.elzalira.org</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-slate-600">SSL</span>
                  <span className="text-sm font-semibold text-green-600">Secured</span>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </AdminDashboard>
  );
};
